export default __webpack_public_path__ + "static/media/codeart-logo-big.2642d1a6.png";